import React from "react";
import { FaUsers, FaClock, FaChalkboardTeacher, FaHeadset } from "react-icons/fa";

const features = [
    {
        id: 1,
        icon: <FaUsers size={30} className="text-blue-500" />,
        title: "Collaborative Learning",
        description:
            "Engage with fellow learners and mentors through interactive sessions and a vibrant learning community.",
    },
    {
        id: 2,
        icon: <FaClock size={30} className="text-blue-500" />,
        title: "Flexible Learning Options",
        description:
            "Access session recordings anytime to ensure continuous progress at your own pace, without missing out.",
    },
    {
        id: 3,
        icon: <FaChalkboardTeacher size={30} className="text-blue-500" />,
        title: "Expert Mentorship",
        description:
            "Receive personalized guidance from industry experts and seasoned educators to support your learning journey.",
    },
    {
        id: 4,
        icon: <FaHeadset size={30} className="text-blue-500" />,
        title: "Dedicated Learning Support",
        description:
            "Benefit from end-to-end assistance with a dedicated support team to address your queries and ensure your success.",
    },
];


const LearningExperience = () => {
    return (
        <div className="max-w-7xl mx-auto px-6 py-16 text-left">
            
            <div className="max-w-3xl mb-16">
              <span className="pd-badge mb-4">
                Structured Learning
              </span>
              <h2 className="text-4xl font-extrabold text-gray-900 tracking-tight leading-none mt-2">
                Engaging Learning Experience
              </h2>
              <p className="text-gray-500 text-sm mt-4 leading-relaxed">
                Our learning model is built around interactivity, constant feedback, and structured peer collaboration.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                {features.map((feature) => (
                    <div
                        key={feature.id}
                        className="relative bg-white border border-gray-100/80 p-8 rounded-3xl text-left hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col justify-between"
                    >
                        <div>
                          <div className="bg-blue-50/60 w-12 h-12 rounded-2xl flex items-center justify-center mb-6">
                              {feature.icon}
                          </div>
                          <h3 className="text-lg font-bold text-gray-900 mb-3">{feature.title}</h3>
                          <p className="text-gray-500 text-sm leading-relaxed font-semibold">{feature.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LearningExperience;
